<template>
  <filter-summary
    icon="customers"
    title="顧客グループ"
    :scroll-to-id="scrollToId"
    v-on="$listeners"
    >{{ filename }}</filter-summary
  >
</template>

<script>
import FilterSummary from '@/components/FilterSummary.vue'

/**
 * 「店舗」の目次
 */
export default {
  components: { FilterSummary },
  props: {
    scrollToId: String,
    file: {
      type: [File, Object],
    },
    customerGroupId: {
      type: String,
    },
  },
  computed: {
    filename() {
      if (this.file && this.file.name) {
        return this.file.name
      } else if (this.customerGroupId) {
        return '選択顧客'
      } else {
        return '全顧客'
      }
    },
    listeners() {
      return {
        ...this.$listeners,
      }
    },
  },
}
</script>
